<template>
    <div class="p-2">
        <validation-observer ref="subscription">
            <b-form-group
                :label="$t('Component(Label):application')"
                label-for="application"
            >
                <v-select
                    v-model="application"
                    id="application"
                    label="title"
                    :placeholder="$t('Component(Label):application')"
                    :options="applicationOptions"
                />
            </b-form-group>
            <b-form-group
                :label="$t('Component(Label):valid-from')"
                label-for="valid-from"
            >
                <b-form-datepicker
                    id="valid-from"
                    v-model="validFrom"
                    :placeholder="$t('Component(Placeholder):valid-from')"
                    :date-format-options="$store.state.component.datePicker.format"
                    :locale="$store.state.component.datePicker.locale"
                />
            </b-form-group>

            <b-form-group
                :label="$t('Component(Label):valid-to')"
                label-for="valid-to"
            >
                <b-form-datepicker
                    id="valid-to"
                    v-model="validTo"
                    :placeholder="$t('Component(Placeholder):valid-to')"
                    :date-format-options="$store.state.component.datePicker.format"
                    :locale="$store.state.component.datePicker.locale"
                />
            </b-form-group>
        </validation-observer>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {BCard, BCardTitle, BFormGroup, BFormDatepicker} from 'bootstrap-vue'
import {Application} from "@/libs/application";
import vSelect from 'vue-select'

export default {
    components: {
        ValidationProvider, ValidationObserver, BFormDatepicker, BFormGroup, BCard, BCardTitle, vSelect
    },
    props: {
        subscription: {}
    },
    data() {
        return {
            application: null,
            validFrom: null,
            validTo: null,
            applicationOptions: Application.all().map(app => this.formApplicationOptionValue(app))
        };
    },
    methods: {
        emit() {
            this.$emit('input', this.getData());
        },
        formApplicationOptionValue(app) {
            return {
                id: app,
                title: app
            }
        },
        getData() {
            return {
                application: this.application ? this.application.id : null,
                validFrom: this.validFrom,
                validTo: this.validTo
            };
        },
        populate(subscription) {
            if (subscription) {
                this.application = subscription.application ? this.formApplicationOptionValue(subscription.application) : null;
                this.validFrom = subscription.validFrom;
                this.validTo = subscription.validTo;
            }
        },
        isValid() {
            return this.application && this.validFrom && this.validTo;
        }
    },
}
</script>

<style scoped>

</style>
